import { render, staticRenderFns } from "./NormalSearchNav211.vue?vue&type=template&id=a0872972&scoped=true&"
import script from "./NormalSearchNav211.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav211.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0872972",
  null
  
)

export default component.exports